export default __webpack_public_path__ + "static/slide4-1440b73d867b7fe91b166607265eca33.jpg";